export default "__VITE_ASSET__C_AkTQdA__"